'use strict';

const ConfigCrypto = require('./files/ConfigCrypto');
const CryptoEngine = require('./files/CryptoEngine');
const KeyPath = require('./files/KeyPath');
const Logger = require('./files/Logger');

/**
 * @soitron/json-value-crypto
 *
 * Knižnica na šifrovanie a dešifrovanie vybraných hodnôt
 * v JSON konfiguračných súboroch pomocou AES-256-GCM.
 *
 * Exportuje štyri triedy:
 * - {@link ConfigCrypto} — vysokoúrovňové API nad celými JSON objektmi
 * - {@link CryptoEngine} — nízkoúrovňové šifrovanie jednotlivých hodnôt a správa pepperu
 * - {@link KeyPath} — traversal JSON objektov cez dot notáciu
 * - {@link Logger} — logovanie s verbose, dry-run a injektovaním externého loggera
 *
 * Pozn.: CLI binárka sa z historických dôvodov volá `json-config-encrypt`
 * (viď pole `bin` v package.json), názov balíka je `@soitron/json-value-crypto`.
 *
 * @module @soitron/json-value-crypto
 *
 * @example
 * const { ConfigCrypto } = require('@soitron/json-value-crypto');
 *
 * // Dešifrovanie pri štarte aplikácie
 * const crypto = new ConfigCrypto({ password: process.env.CONFIG_SECRET });
 * const config = crypto.decryptObject(zašifrovanýKonfig);
 *
 * @example
 * // Šifrovanie vybraných kľúčov
 * const crypto = new ConfigCrypto({ password: 'moje-heslo' });
 * const encrypted = crypto.encryptByKeys(konfig, ['db.connect.password', 'api.secret']);
 */
module.exports = {
  ConfigCrypto,
  CryptoEngine,
  KeyPath,
  Logger,
};
